// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `ahead`
};

const de_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `voraus`
};

const es_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `por delante`
};

const fr_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `en avance`
};

const fi_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `edellä`
};

const hi_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `आगे`
};

const ja_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `リード`
};

const nl_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `voor`
};

const pt_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `à frente`
};

const ro_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `înaintea`
};

const th_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `นำหน้า`
};

const ur_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `آگے`
};

const zh_hant1_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `領先`
};

const da_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `foran`
};

const it_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `avanti`
};

const vn_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `dẫn trước`
};

const ko_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `앞서`
};

const tr_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `önde`
};

const lv_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `priekšā`
};

const ar_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `متقدم`
};

const bs_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `ispred`
};

const sl_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `pred`
};

const id_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `di depan`
};

const sv_widget_leaderboard_ahead = /** @type {(inputs: {}) => string} */ () => {
	return `före`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_ahead = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_ahead(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_ahead", locale)
	if (locale === "en") return en_widget_leaderboard_ahead(inputs)
	if (locale === "de") return de_widget_leaderboard_ahead(inputs)
	if (locale === "es") return es_widget_leaderboard_ahead(inputs)
	if (locale === "fr") return fr_widget_leaderboard_ahead(inputs)
	if (locale === "fi") return fi_widget_leaderboard_ahead(inputs)
	if (locale === "hi") return hi_widget_leaderboard_ahead(inputs)
	if (locale === "ja") return ja_widget_leaderboard_ahead(inputs)
	if (locale === "nl") return nl_widget_leaderboard_ahead(inputs)
	if (locale === "pt") return pt_widget_leaderboard_ahead(inputs)
	if (locale === "ro") return ro_widget_leaderboard_ahead(inputs)
	if (locale === "th") return th_widget_leaderboard_ahead(inputs)
	if (locale === "ur") return ur_widget_leaderboard_ahead(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_ahead(inputs)
	if (locale === "da") return da_widget_leaderboard_ahead(inputs)
	if (locale === "it") return it_widget_leaderboard_ahead(inputs)
	if (locale === "vn") return vn_widget_leaderboard_ahead(inputs)
	if (locale === "ko") return ko_widget_leaderboard_ahead(inputs)
	if (locale === "tr") return tr_widget_leaderboard_ahead(inputs)
	if (locale === "lv") return lv_widget_leaderboard_ahead(inputs)
	if (locale === "ar") return ar_widget_leaderboard_ahead(inputs)
	if (locale === "bs") return bs_widget_leaderboard_ahead(inputs)
	if (locale === "sl") return sl_widget_leaderboard_ahead(inputs)
	if (locale === "id") return id_widget_leaderboard_ahead(inputs)
	if (locale === "sv") return sv_widget_leaderboard_ahead(inputs)
	return "widget_leaderboard_ahead"
};